import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import TrimmedMedia from './trimmed-media-model'
import {
  CreateTrimmedMediaAsync,
  DeleteTrimmedMediaAsync,
  LoadTrimmedMediasAsync,
} from './trimmedMedia-thunk'
const initialState: trimmedMediaSliceState = {
  trimmedMedia: [],
  selected_trimmedMedia: '',
  is_loading_trimmedMedia: false,
  is_creating_trimmedMedia: false,
  is_deleting_trimmedMedia: false,
}
export interface trimmedMediaSliceState {
  trimmedMedia: TrimmedMedia[]
  selected_trimmedMedia?: string
  is_loading_trimmedMedia: boolean
  is_creating_trimmedMedia: boolean
  is_deleting_trimmedMedia: boolean
}
export const trimmedMediaSlice = createSlice({
  name: 'trimmedMedia',
  initialState,
  reducers: {
    setSelectedtrimmedMedia: (state, action) => {
      state.selected_trimmedMedia = action.payload
    },
    clearStatetrimmedMedia: (state) => {
      state.trimmedMedia = []
      state.is_loading_trimmedMedia = false
      state.is_creating_trimmedMedia = false
      state.is_deleting_trimmedMedia = false
    },
    mergetrimmedMedia: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_trimmedMedia = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.trimmedMedia = merge(state.trimmedMedia, payload) as any
        }
      }
    },

    add_trimmedMedia: (state, action) => {
      if (action.payload) {
        state.trimmedMedia = [...state.trimmedMedia, action.payload]
      }
    },
    set_trimmedMedia: (state, action) => {
      let { key, value, id } = action.payload
      state.trimmedMedia = state.trimmedMedia.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadTrimmedMediasAsync.pending, (state) => {
      state.is_loading_trimmedMedia = true
    })
    builder.addCase(LoadTrimmedMediasAsync.fulfilled, (state, action) => {
      state.is_loading_trimmedMedia = false
      if (action.payload) {
        state.trimmedMedia = action.payload
      }
    })
    builder.addCase(LoadTrimmedMediasAsync.rejected, (state) => {
      state.is_loading_trimmedMedia = false
    })
    builder.addCase(CreateTrimmedMediaAsync.pending, (state) => {
      state.is_creating_trimmedMedia = true
    })
    builder.addCase(CreateTrimmedMediaAsync.fulfilled, (state) => {
      state.is_creating_trimmedMedia = false
    })
    builder.addCase(CreateTrimmedMediaAsync.rejected, (state) => {
      state.is_creating_trimmedMedia = false
    })
    builder.addCase(DeleteTrimmedMediaAsync.pending, (state) => {
      state.is_deleting_trimmedMedia = true
    })
    builder.addCase(DeleteTrimmedMediaAsync.fulfilled, (state, action) => {
      state.is_deleting_trimmedMedia = false
      if (state.trimmedMedia) {
        state.trimmedMedia = state.trimmedMedia.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteTrimmedMediaAsync.rejected, (state) => {
      state.is_deleting_trimmedMedia = false
    })

    builder.addCase(autoThunks.get_trimmed_media.pending, (state) => {
      state.is_loading_trimmedMedia = true
    })
    builder.addCase(autoThunks.get_trimmed_media.fulfilled, (state, action) => {
      state.is_loading_trimmedMedia = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.get_trimmed_media.rejected, (state) => {
      state.is_loading_trimmedMedia = false
    })
  },
})

function handleResult(action: any, state: trimmedMediaSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_trimmedMedia = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.trimmedMedia = merge(state.trimmedMedia, payload) as any
    }
  }
}

export const {
  clearStatetrimmedMedia,
  setSelectedtrimmedMedia,
  set_trimmedMedia,
  mergetrimmedMedia,
  add_trimmedMedia,
} = trimmedMediaSlice.actions

export const get_trimmedMedia =
  (id?: string) =>
  (state: {
    trimmedMedia: {
      trimmedMedia: TrimmedMedia[]
    }
  }): TrimmedMedia | null => {
    let temp = state?.trimmedMedia?.trimmedMedia?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.trimmedMedia?.trimmedMedia[0] || null
  }
export const get_selected_trimmedMedia = (state: {
  trimmedMedia: trimmedMediaSliceState
}): TrimmedMedia | null => {
  let id = state?.trimmedMedia?.selected_trimmedMedia
  let temp = state?.trimmedMedia?.trimmedMedia?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_trimmedMedia = (state: {
  trimmedMedia: {
    trimmedMedia: TrimmedMedia[]
  }
}): TrimmedMedia[] => {
  let temp = state?.trimmedMedia?.trimmedMedia
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_trimmedMedia_busy = (state: {
  trimmedMedia: trimmedMediaSliceState
}) => {
  return (
    state?.trimmedMedia.is_deleting_trimmedMedia ||
    state?.trimmedMedia.is_loading_trimmedMedia ||
    state?.trimmedMedia.is_creating_trimmedMedia
  )
}
export const is_deleting_trimmedMedia_busy = (state: {
  trimmedMedia: trimmedMediaSliceState
}) => {
  return state?.trimmedMedia.is_deleting_trimmedMedia
}
export const is_loading_trimmedMedia_busy = (state: {
  trimmedMedia: trimmedMediaSliceState
}) => {
  return state?.trimmedMedia.is_loading_trimmedMedia
}
export const is_creating_trimmedMedia_busy = (state: {
  trimmedMedia: trimmedMediaSliceState
}) => {
  return state?.trimmedMedia.is_creating_trimmedMedia
}

export default trimmedMediaSlice.reducer
